import { render, staticRenderFns } from "./saveResourceBtn.vue?vue&type=template&id=2fefb9ff&scoped=true"
import script from "./saveResourceBtn.vue?vue&type=script&lang=js"
export * from "./saveResourceBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fefb9ff",
  null
  
)

export default component.exports